import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import ThSort from '../common/table/thSort';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './producaoForm';
import { setError } from '../common/toast/toast';
import readXlsxFile from 'read-excel-file/web-worker'
import Aguardando from '../common/template/aguardando';
import FormatUtils from '../common/formatUtils/FormatUtils';
import InputPesquisa from '../common/form/inputPesquisa';
import ReactExport from 'react-export-excel-fixed-xlsx';
import { sortData } from '../common/table/sortHelper';
import DateFormat from '../common/dateFormat/DateFormat';
import LabelAndInputDate from '../common/form/labelAndInputDate';

import { setModoTela, setFiltro, initForm, salvar, excluir, getLista, getListaSolicitacoes, gerarPdf } from './producaoActions';
import { getLista as getListaParceiro } from '../parceiro/parceiroActions';
import { getLista as getListaRacao } from '../racao/racaoActions';
import { getLista as getListaUnidadeMedida } from '../unidadeMedida/unidadeMedidaActions';
import { getLista as getListaEquipamento } from '../equipamento/equipamentoActions';
import { getLista as getListaVeiculo } from '../veiculo/veiculoActions';
import { getLista as getListaMotorista } from '../motorista/motoristaActions';

const columns = [{
    field: 'ordem',
    type: 'int'
}, {
    field: 'id',
    type: 'int'
}, {
    field: 'id_solicitacao',
    type: 'int'
}, {
    field: 'nome_racao',
    type: 'text'
}, {
    field: 'quantidade',
    type: 'decimal'
}, {
    field: 'sigla_unidade_medida',
    type: 'text'
}, {
    field: 'data_agendamento',
    type: 'date'
}, {
    field: 'datahora_inicio',
    type: 'date'
}, {
    field: 'datahora_fim',
    type: 'date'
}];

class Producao extends Component {

	state = {
		linhaSelecionada: null,
		sort: {
			field: 'ordem',
			direction: 'asc' // 'asc' | 'desc'
		}
	}

	componentDidMount() {

	}

    componentWillMount() {
        this.props.getLista();
		this.props.getListaSolicitacoes();
		this.props.getListaParceiro();
		this.props.getListaRacao();
		this.props.getListaUnidadeMedida();
		this.props.getListaEquipamento();
		this.props.getListaVeiculo();
		this.props.getListaMotorista()
    }

    render() {
        return (
            <div>
                <Content>
					<Aguardando aguardando={this.props.aguardando} />

					{this.props.modoTela == 'cadastro' ? (
						<Form onSubmit={this.props.salvar} />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<Form excluir onSubmit={this.props.excluir} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
                </Content>
            </div>
        )
    }

	filtrar() {
		const listaFiltrada = this.props.lista.filter(item => {
			return !(this.state.pesquisar || '').trim()
			|| (this.state.pesquisar.toUpperCase() || '')
				.split('+')
				.filter(p => p.trim())
				.every(pesquisar => `
					${item.id}
					${item.id_solicitacao}
					${DateFormat.formatarDataSqlParaTela(item.data_agendamento)}
					${DateFormat.formatarDataHoraSqlParaTela(item.datahora_inicio)}
					${DateFormat.formatarDataHoraSqlParaTela(item.datahora_fim)}
					${item.nome_racao}
					${FormatUtils.formatarValorTela(item.quantidade, 2)}
					${item.sigla_unidade_medida}
				`.toUpperCase().includes(pesquisar)
				);
		}).map(item => ({
			...item,
			quantidade: FormatUtils.formatarValorTela(item.quantidade, 2)
		}));

		return sortData(
			listaFiltrada,
			this.state.sort,
			columns
		);
	}
	
	onSort(field) {
		this.setState(prev => {
			let direction = 'asc';

			if (prev.sort.field === field) {
				direction = prev.sort.direction === 'asc' ? 'desc' : 'asc';
			}

			return {
				sort: { field, direction }
			};
		});
	}

	lista() {

		const ExcelFile = ReactExport.ExcelFile;

		const listaAux = this.filtrar();

		let lista = [];
		listaAux.forEach(item => {
			lista.push(item)
		});		

		let setLinhaSelecionada = (id) => {
			this.setState({
				...this.state,
				linhaSelecionada: id
			});
		}

		return (
			<ContentCard>
				<ContentCardHeader>
					<Row>
						{/*<InputPesquisa
							cols='12 6 3 1'
							label='Pesquisar'
							minWidth={344}
							onChange={value => this.setState({ ...this.state, pesquisar: value })} />*/}

						<LabelAndInputDate
							label='Data'
							cols='12 1 1 1'
							value={this.props.filtro.data}
							onChange={value => {
								this.props.setFiltro({
									...this.props.filtro,
									data: value
								});
							}} />

						<div style={{ marginTop: 8, width: 270 }}>
							<a class='btn btn-app bg-primary' style={{ marginLeft: 2, minWidth: 75 }}
								onClick={() => {
									this.props.getLista();
									this.props.getListaSolicitacoes();
								}}>
								<i class='fas fa-sync-alt'></i> Atualizar
							</a>
							<ExcelFile
								filename={'Producões'}
								element={
									<a class='btn btn-app bg-success' style={{ marginLeft: 2, minWidth: 75 }}>
										<i class='fas fa-file-excel'></i> Exportar
									</a>
								}>
								{this.montarExcel(lista)}
							</ExcelFile>
							{!!this.props.lista.length &&
							<a class='btn btn-app bg-success' style={{ marginLeft: 2, minWidth: 75 }}
								onClick={() => {
									this.props.gerarPdf(this.props.lista);
								}}>
								<i class='fas fa-file-pdf'></i> Gerar PDF
							</a>}
						</div>
					</Row>
				</ContentCardHeader>
				<ContentCardBody>
					<Table responsive border alturaFixa striped
						maxHeight={window.innerWidth < 631 ? window.innerHeight - 260 : window.innerHeight - 180}>
						<THead>
							<Tr>
								<ThSort
									field='ordem'
									label='Ordem'
									width={10}
								/>

								<ThSort
									field='id'
									label='Número'
									width={10}
								/>

								<ThSort
									field='id_solicitacao'
									label='Solicitação'
									width={10}
								/>

								<ThSort
									field='nome_parceiro'
									label='Parceiro'
									width={200}
								/>

								<ThSort
									field='nome_racao'
									label='Ração'
									width={200}
								/>

								<ThSort
									field='quantidade'
									label='Quantidade'
									width={80}
								/>

								<ThSort
									field='data_agendamento'
									label='Agendamento'
									width={10}
								/>

								<ThSort
									field='entregador'
									label='Entregador'
									width={200}
								/>

								<ThSort
									field='datahora_inicio'
									label='Início da Produção'
									width={80}
								/>

								<ThSort
									field='datahora_fim'
									label='Fim da Produção'
									width={80}
								/>

								<Th sticky alignCenter width={50}></Th>
							</Tr>
						</THead>
						<TBody>
							{lista.map((item, i) => (
								<Tr key={i}
									backgroundColor={this.state.linhaSelecionada == item.id ? '#bcc7eb' : (i % 2 == 0 ? '#ffffff' : '#f5f5f5')} >
									<Td onClick={() => setLinhaSelecionada(item.id)} alignCenter>
										<div
											style={{
												display: 'flex',
												flexDirection: 'row',
												justifyContent: 'center',
												alignItems: 'center'
											}}>
											<div
												style={{
													display: 'flex',
													flexDirection: 'row',
													justifyContent: 'center',
													alignItems: 'center',
													paddingLeft: 8,
													paddingRight: 8,
													width: 32,
													height: 32,
													fontWeight: 'bold',
													backgroundColor: '#6c757d',
													color: '#ffffff',
													borderRadius: '50%'
												}}>
												{item.ordem}
											</div>
										</div>
									</Td>
									<Td onClick={() => setLinhaSelecionada(item.id)} alignCenter>{item.id}</Td>
									<Td onClick={() => setLinhaSelecionada(item.id)} alignCenter>{item.id_solicitacao}</Td>
									<Td onClick={() => setLinhaSelecionada(item.id)} alignCenter>{item.nome_parceiro}</Td>
									<Td onClick={() => setLinhaSelecionada(item.id)} alignCenter>{item.nome_racao}</Td>
									<Td onClick={() => setLinhaSelecionada(item.id)} alignCenter>{item.quantidade} {item.sigla_unidade_medida}</Td>
									<Td onClick={() => setLinhaSelecionada(item.id)} alignCenter>{DateFormat.formatarDataSqlParaTela(item.data_agendamento)}</Td>
									<Td onClick={() => setLinhaSelecionada(item.id)} alignCenter>
										<div>{item.placa_veiculo}</div>
										<div style={{ fontSize: 10 }}>{item.nome_motorista}</div>
									</Td>
									<Td onClick={() => setLinhaSelecionada(item.id)} alignCenter>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_inicio)}</Td>
									<Td onClick={() => setLinhaSelecionada(item.id)} alignCenter>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_fim)}</Td>
									<Td alignCenter minWidth={130} maxWidth={130}>
										<ButtonTable
											type={'success'}
											width={32}
											small
											icon={'fas fa-play'}
											visible={true}
											title='Executar'
											event={() => {
												this.props.setModoTela('cadastro', {
													...item
												});
												this.props.initForm({
													...item
												});
											}} />

										{/*<ButtonTable
											type={'danger'}
											width={32}
											small
											icon={'fas fa-trash-alt'}
											visible={!item.datahora_inicio}
											title='Excluir'
											event={() => {
												this.props.setModoTela('exclusao', {
													...item
												});
												this.props.initForm({
													...item
												});
											}} />*/}
									</Td>
								</Tr>
							))}
						</TBody>
					</Table>
				</ContentCardBody>
			</ContentCard>
		);
	}

	montarExcel(lista) {

		const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
		const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

		return (
			<ExcelSheet data={lista.map(item => ({
				...item,
				data_agendamento: DateFormat.formatarDataSqlParaTela(item.data_agendamento),
				datahora_solicitacao: DateFormat.formatarDataHoraSqlParaTela(item.datahora_solicitacao),
				datahora_solicitacao: DateFormat.formatarDataHoraSqlParaTela(item.datahora_solicitacao),
				quantidade: parseFloat(FormatUtils.formatarValorBanco(item.quantidade, 2))
			}))} name='Producões'>
				{[
					{ componente: <ExcelColumn key={1} label='Ordem' value='ordem'/>},
					{ componente: <ExcelColumn key={2} label='Número' value='id'/>},
					{ componente: <ExcelColumn key={3} label='Solicitação' value='id_solicitacao'/>},
					{ componente: <ExcelColumn key={4} label='Agendamento' value='data_agendamento'/>},
					{ componente: <ExcelColumn key={5} label='Parceiro' value='nome_parceiro'/>},
					{ componente: <ExcelColumn key={6} label='Silo' value='solicitacao_silo'/>},
					{ componente: <ExcelColumn key={7} label='Lote' value='solicitacao_lote'/>},
					{ componente: <ExcelColumn key={8} label='Ração' value='nome_racao'/>},
					{ componente: <ExcelColumn key={9} label='Quantidade' value='capacidade' type='number'/>},
					{ componente: <ExcelColumn key={10} label='Unidade de Medida' value='sigla_unidade_medida'/>},
					{ componente: <ExcelColumn key={11} label='Motorista' value='nome_motorista'/>},
					{ componente: <ExcelColumn key={12} label='Veículo' value='placa_veiculo'/>},
					{ componente: <ExcelColumn key={13} label='Usuário da Inclusão' value='nome_usuario_inclusao'/>},
					{ componente: <ExcelColumn key={14} label='Usuário da Alteração' value='nome_usuario_alteproducao'/>}
				].filter(item => {
					return true;
				}).map(item => (
					item.componente
				))}
			</ExcelSheet>
		);
	}

}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	modoTela: state.producao.modoTela,
	filtro: state.producao.filtro,
	aguardando: state.producao.aguardando,
	lista: state.producao.lista.filter(item => item.datahora_confirmacao)
});
const mapDispatchToProps = dispatch => bindActionCreators({ 
	setModoTela, setFiltro, initForm, salvar, excluir, getLista, getListaSolicitacoes, gerarPdf,
	getListaParceiro, getListaRacao, getListaUnidadeMedida, getListaEquipamento,
	getListaVeiculo, getListaMotorista
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(Producao);